import { makeItemsNav } from '@helpers/helper.rendering'
import { Link } from 'gatsby'
import React, { useState, useEffect } from 'react'
import { Accordion, Container, Nav } from 'react-bootstrap'
import { RealEstateDataHeaderData, StatePropertiesSlice } from 'types'
import { useLocation } from '@reach/router'
import '@boilerplates/header/1/index.scss'
import { useSelector } from 'react-redux'
import { getfavorites } from '@helpers/helper.favorites'
import toast, { Toaster } from 'react-hot-toast'
import $ from 'jquery'
import { useGetSummarySiteQuery } from '@apis/mediacore/core'

const isBrowser = typeof window !== 'undefined'

const Header10 = (
  props: RealEstateDataHeaderData & {
    development_id: string
    property_id: string
    novelty_id: string
    disableScrollHide?: boolean
  },
) => {
  const {
    pages,
    global_data,
    hiddenLogo,
    leftSide,
    buttonCompare,
    divisions,
    isInverted,
    background_secondary,
    textUppercase,
    is_short,
    sticky,
    bigContent,
    logoSize,
    fontColor,
    hoverColor,
    spanText,
    disableScrollHide = false,
    height,
    hiddenMenu,
    items,
  } = props
  const { divisionPath, id: siteId } = global_data
  const { pathname } = useLocation()

  useEffect(() => {
    if (!height || !isBrowser) return
    const mql = window.matchMedia('(max-width: 992px)')

    const applyHeight = ({ matches }: MediaQueryListEvent | MediaQueryList) => {
      const h = matches ? height.mobile : height.desktop
      if (!h) return

      logoRef.current?.style.setProperty('height', h, 'important')
      rowRef.current?.style.setProperty('height', h, 'important')
    }

    applyHeight(mql)
    mql.addEventListener('change', applyHeight)
    return () => mql.removeEventListener('change', applyHeight)
  }, [height?.desktop, height?.mobile])

  const [listFavorites, setListFavorites] = useState(getfavorites('prop', 'template-site'))

  const logo = global_data.logo
  const logoMobile = global_data.logoMobile
  const { updaterFavorites } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!
  const countFavorites = listFavorites.length

  type GroupedItem = {
    title: string
    items: { value?: string; address?: string }[]
  }

  const [open, setOpen] = useState(false)

  const staticBody = () => {
    var body = document.getElementsByTagName('html')[0]
    body.classList.toggle('overflow-hidden')
  }

  useEffect(() => {
    const body = document.querySelector('body') as HTMLElement
    body.style.paddingTop = '0px'
  }, [pathname])

  useEffect(() => {
    setListFavorites(getfavorites('prop', 'template-site'))
  }, [updaterFavorites])

  const SupraNavBar = require(`@components/supraNavBar/1`)?.default

  const [scrollPercentage, setScrollPercentage] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = $(document).height()!
      const clientHeight = $('body').height()!
      const scrollTop = $('body').scrollTop()!
      const percentage = (scrollTop / (scrollHeight - clientHeight)) * 100
      setScrollPercentage(percentage)
    }

    $('body').on('scroll', handleScroll)

    return () => {
      $('body').off('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (hoverColor) {
      document.documentElement.style.setProperty('--hoverColor', hoverColor)
    }
  }, [hoverColor])

  useEffect(() => {
    if (fontColor) {
      document.documentElement.style.setProperty('--dashedColor', fontColor)
    }
  }, [fontColor])

  const logoRef = React.useRef<any>(null)
  const rowRef = React.useRef<HTMLDivElement>(null)

  const isCompiler = process.env.GATSBY_IS_SITE_COMPILER === 'true'

  const currentPage = pages?.find(
    (page) =>
      (pathname.replaceAll('/', '') === page.path.replaceAll('/', '') && !isCompiler) ||
      (isCompiler &&
        pathname !== '/' &&
        pathname.replace(global_data.divisionPath!, '').replaceAll('/', '') ===
          page.path.replaceAll('/', '')) ||
      (pathname.includes('/emprendimiento/') && page.path === '/desarrollo_detalle') ||
      (pathname.includes('/propiedad/') && page.path === '/propiedad_detalle') ||
      (pathname.includes('/novedad/') && page.path === '/novedad_detalle'),
  )

  const [isHover, setIsHover] = useState(false)

  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }

  const { data: allSiteData } = useGetSummarySiteQuery(
    process.env.GATSBY_IS_SITE_COMPILER == 'true' ? siteId : process.env.GATSBY_TENANTID,
  )

  const colSizeMobile =
    hiddenMenu && !buttonCompare?.value && !hiddenLogo
      ? 12
      : hiddenMenu
        ? buttonCompare?.value
          ? 6
          : 9
        : buttonCompare?.value && !hiddenLogo
          ? 6
          : 9

  const justifyContentMobile =
    hiddenMenu && !buttonCompare?.value && !hiddenLogo
      ? 'justify-content-center'
      : buttonCompare?.value && !hiddenLogo
        ? 'justify-content-start'
        : 'justify-content-start'

  function groupByTitle(items: any[]) {
    const grouped: any = {}
    for (const item of items) {
      const { title, value, address } = item

      if (!grouped[title]) {
        grouped[title] = { title, items: [] }
      }

      grouped[title].items.push({ value, address })
    }

    return Object.values(grouped)
  }

  function ItemsDropdown({ data }: { data: any[] }) {
    return (
      <Accordion>
        {data.map((group, index) => (
          <Accordion.Item
            eventKey={index.toString()}
            key={group.title}
          >
            <Accordion.Header style={{ color: fontColor }}>{group.title}</Accordion.Header>
            <Accordion.Body
              className="accordion-body-header-10"
              style={{
                border: '1px solid ' + hoverColor,
                background: hoverColor,
                top: height?.desktop,
              }}
            >
              <ul className="list-unstyled text-center mb-0">
                {group.items.map((item: any) => (
                  <li key={item.address}>
                    <Link
                      style={{ color: spanText }}
                      to={item.address}
                    >
                      {item.value}
                    </Link>
                  </li>
                ))}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    )
  }

  return (
    <header
      id="header"
      ref={logoRef}
      style={{ background: spanText }}
      className={`blur b header10 header-2 ${is_short ? 'small-height' : ''} ${
        open ? 'opened' : 'closed'
      } ${hiddenLogo && ' hidden-logo '} ${background_secondary && 'background-secondary'}${process.env.GATSBY_IS_SITE_COMPILER === 'true' ? ' is_multisite' : ' '} ${
        sticky ? ' position-sticky ' : ''
      } ${
        !disableScrollHide &&
        parseInt(scrollPercentage.toFixed(2)) > 85 &&
        !currentPage?.hidden_footer
          ? ' opacity'
          : ''
      }
 ${bigContent ? ' is-extended' : ''}`}
    >
      <Toaster
        toastOptions={{ className: 'toast-className', style: { maxWidth: 'fit-content' } }}
      />
      <Nav
        className="brand"
        style={{ background: spanText }}
        ref={logoRef}
      >
        {process.env.GATSBY_IS_SITE_COMPILER === 'true' && (
          <div className="divisions-nav d-flex align-items-center">
            <Container
              className="d-flex align-items-center justify-lg-content-between"
              fluid
            >
              <Link
                className={'px-0 ' + (isInverted ? 'd-lg-block' : 'd-lg-none')}
                style={{ opacity: 1 }}
                to="/"
              >
                <img
                  src={logo}
                  style={{
                    maxHeight: logoSize
                      ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 +
                        'px'
                      : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                    height: logoSize
                      ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 +
                        'px'
                      : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                  }}
                />
              </Link>

              <SupraNavBar
                divisions={divisions}
                divisionPath={divisionPath}
              />
            </Container>
          </div>
        )}
        <div className="container-fluid">
          <div
            className={`row ${
              leftSide ? 'justify-content-lg-start' : 'justify-content-lg-between'
            } align-items-center ${
              process.env.GATSBY_IS_SITE_COMPILER === 'true'
                ? 'justify-content-end'
                : 'justify-content-between'
            }`}
            ref={rowRef}
          >
            {/* {buttonCompare?.value && (
              <div className="col-3 d-lg-none d-flex align-items-center justify-content-start order-1">
                {allSiteData?.propiedades?.objects?.operation_types?.length > 0 &&
                  (countFavorites === 0 ? (
                    <div
                      className="btn btn-white btn-compare disabled-compare border d-flex align-items-center justify-content-center"
                      onClick={() => toast.error('No tienes propiedades favoritas seleccionadas.')}
                    >
                      <i
                        className={`icon-favoritos-heart` + (countFavorites < 1 && ' disabled ')}
                      ></i>
                      <div
                        className="mx-2"
                        style={{ fontStyle: 'normal' }}
                      >
                        {countFavorites}
                      </div>
                    </div>
                  ) : (
                    <Link to={buttonCompare.link}>
                      <div className="btn btn-white btn-compare border d-flex align-items-center justify-content-center">
                        <i
                          className={`icon-favoritos-heart`}
                          style={{ color: fontColor }}
                        ></i>
                        <div
                          className="mx-2"
                          style={{ fontStyle: 'normal', color: fontColor }}
                        >
                          {countFavorites}
                        </div>
                      </div>
                    </Link>
                  ))}
              </div>
            )} */}

            <div
              className={`col-${colSizeMobile} col-lg-1 d-flex ${justifyContentMobile} justify-content-lg-start ${leftSide ? 'order-2 order-lg-2' : 'order-2 order-lg-1'}`}
            >
              {!isInverted && (
                <Link
                  to={'/'}
                  className="logo d-none d-lg-flex align-items-center"
                >
                  <img
                    className="logo-header"
                    style={{
                      maxHeight: logoSize
                        ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 +
                          'px'
                        : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                      height: logoSize
                        ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 +
                          'px'
                        : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                    }}
                    src={logo}
                  ></img>
                </Link>
              )}
              {!isInverted && (
                <Link
                  to={'/'}
                  className="logo d-flex align-items-center justify-content-start d-lg-none"
                >
                  <img
                    className="logo-header"
                    src={logoMobile}
                    style={{
                      maxHeight: logoSize
                        ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 +
                          'px'
                        : (logoRef?.current?.clientHeight * 70) / 100 + 'px',
                      height: logoSize
                        ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 +
                          'px'
                        : (logoRef?.current?.clientHeight * 70) / 100 + 'px',
                    }}
                  ></img>
                </Link>
              )}
            </div>
            <div
              className={`col-3 col-lg-11  d-flex ${
                leftSide
                  ? 'order-3 order-lg-1 justify-content-lg-start justify-content-end'
                  : 'order-3 order-lg-2 justify-content-end text-right'
              }`}
            >
              <ul
                className={`nav-menu d-none d-lg-flex  ${
                  leftSide ? 'justify-content-start' : 'justify-content-lg-end'
                }`}
              >
                {makeItemsNav(
                  allSiteData?.propiedades,
                  allSiteData?.novedades,
                  pages,
                  allSiteData?.posiciones,
                )
                  .filter((page) => !page.path.includes('detalle'))
                  .map(({ path, title }, index) => (
                    <Nav.Item key={index}>
                      <Link
                        onClick={() => {
                          ;(setOpen(false),
                            document
                              .getElementsByTagName('html')[0]
                              .classList.remove('overflow-hidden'))
                        }}
                        className={
                          (!textUppercase ? 'text-uppercase ' : 'text-none ') +
                          pathname +
                          ': ' +
                          +' , ' +
                          path +
                          ' ' +
                          ((pathname.includes(path) && pathname !== '' && path !== '/') ||
                          (pathname.includes('novedad/') && path.includes('novedades')) ||
                          (path === '/' && pathname === '/') ||
                          (pathname.toLowerCase() === divisionPath?.toLowerCase() + '/' &&
                            path === '/')
                            ? 'text-underline'
                            : '')
                        }
                        style={{ color: fontColor }}
                        to={(divisionPath ?? '') + path}
                      >
                        {title}
                      </Link>
                    </Nav.Item>
                  ))}
                {
                  items && <ItemsDropdown data={groupByTitle(items)} />
                  // groupByTitle(items)?.map((item, index) => (
                  //   <Nav.Item key={index}>
                  //     <li key={index}>
                  //       {item.title}
                  //       {item.items.map(({ address, value }) => (
                  //         <Link to={address!}>{value}</Link>
                  //       ))}
                  //     </li>
                  //   </Nav.Item>
                  // ))
                }
              </ul>
              {buttonCompare?.value &&
                allSiteData?.propiedades?.objects?.operation_types?.length > 0 &&
                (countFavorites === 0 ? (
                  <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    style={{
                      background: buttonCompare?.secondary ? buttonCompare?.backgroundColor : '',
                    }}
                    className={
                      'btn-compare disabled-compare border d-lg-flex d-none align-items-center justify-content-center ' +
                      (buttonCompare?.secondary ? '' : ' btn btn-white')
                    }
                    onClick={() => toast.error('No tienes propiedades favoritas seleccionadas.')}
                  >
                    {screen.width > 992 ? buttonCompare?.value : ''}
                    <div
                      className="mx-3"
                      style={{ fontStyle: 'normal' }}
                    >
                      {countFavorites}
                    </div>
                    <i
                      className={`icon-favoritos-heart` + (countFavorites < 1 && ' disabled ')}
                    ></i>
                  </div>
                ) : (
                  <Link to={buttonCompare?.link}>
                    <div
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      style={{
                        backgroundColor: buttonCompare?.secondary
                          ? isHover
                            ? buttonCompare?.valueColor
                            : buttonCompare?.backgroundColor
                          : '',
                        color: buttonCompare?.secondary
                          ? isHover
                            ? buttonCompare?.backgroundColor
                            : buttonCompare?.valueColor
                          : '',
                      }}
                      className={`btn-compare d-lg-flex d-none align-items-center justify-content-center ${buttonCompare?.secondary ? '' : ' btn btn-white'} ${buttonCompare?.border ? 'border' : ''}`}
                    >
                      {screen.width > 992 ? buttonCompare?.value : ''}
                      <div
                        className="mx-3"
                        style={{
                          fontStyle: 'normal',
                          color: buttonCompare?.secondary
                            ? isHover
                              ? buttonCompare?.backgroundColor
                              : buttonCompare?.valueColor
                            : '',
                        }}
                      >
                        {countFavorites}
                      </div>
                      <i
                        style={{
                          color: buttonCompare?.secondary
                            ? isHover
                              ? buttonCompare?.backgroundColor
                              : buttonCompare?.valueColor
                            : '',
                        }}
                        className={`icon-favoritos-heart`}
                      ></i>
                    </div>
                  </Link>
                ))}
              {!hiddenMenu && (
                <button
                  className="d-block d-lg-none"
                  id="toggle-nav"
                  onClick={() => {
                    setOpen(!open)
                    staticBody()
                  }}
                >
                  <div className="d-flex align-items-center">
                    <span className="status_nav d-none d-lg-inline">Menú </span>
                    <span className="ms-4">
                      <i></i>
                      <i></i>
                      <i></i>
                    </span>
                  </div>
                </button>
              )}
            </div>
          </div>
        </div>
      </Nav>
    </header>
  )
}

export default Header10
